import React from 'react';
import { useTranslation } from 'react-i18next';

import { ScreeningData } from '~/stores/use-chat/assistant-response.type';

import { ScreeningMessageData } from './screening-message-data/ScreeningMessageData';

type ScreeningMessageProps = {
  data: ScreeningData;
};

export const ScreeningMessage = ({ data }: ScreeningMessageProps) => {
  const { t } = useTranslation('intel');

  if (data.entities.length) {
    return <ScreeningMessageData entities={data.entities} />;
  }

  return <p>{t('intel:screening.empty')}</p>;
};
